import { AxiosError } from "axios";
import api from "./axiosConfig";
import { ApiResponse, UserProfile } from "./types";

const BASE_PATH = "portal/";

const userService = {
  getProfile: async () => {
    const response = await api.get<UserProfile>(`${BASE_PATH}accounts/profile`);
    return response.data;
  },

  updateProfile: async (data: Partial<UserProfile>) => {
    try {
      const response = await api.put<UserProfile>(`${BASE_PATH}accounts`, data);
      return response.data;
    } catch (err: unknown) {
      console.error(err);
      let errMsg;

      if (err instanceof AxiosError) {
        errMsg = err?.response?.data?.error || err?.response?.data || err;
      } else {
        errMsg = "Unexpected error";
      }

      return Promise.reject({ message: errMsg });
    }
  },

  getPointsBalance: async () => {
    const response = await api.get<ApiResponse<{ points: number }>>(
      "/user/points"
    );
    return response.data;
  },
};

export default userService;
